import { Injectable } from "@angular/core";
import {publishReplay, refCount, share} from "rxjs/operators";
import { MasterHttpService } from "../generated/master-http.service";
import {ComponentAttributes, MaterialAttributes} from "../types";
import {Component, Material} from "../generated/types";
import { Observable } from "rxjs";

@Injectable()
export class MasterService {

  constructor(private httpService: MasterHttpService) {

  }

  master = this.httpService.get().pipe(share());
  components = this.httpService.getComponents().pipe(share()) as Observable<Record<Component, ComponentAttributes>>;
  materials = this.httpService.getMaterials().pipe(share()) as Observable<Record<Material, MaterialAttributes>>;

}
